import React from 'react';
import Leaderboard from '../../components/common/Leaderboard';
import { Competition } from '../../types/interfaces';

const LeaderboardTab: React.FC<{ competition: Competition }> = ({ competition }) =>
  competition.leaderboard === 'unlisted' ? null : competition.leaderboard === 'public' || competition.leaderboard === 'final' ? (
    <Leaderboard competitionId={competition.id} leaderboardMode={competition.leaderboard} competitionMode={competition.competition_mode} />
  ) : (
    <p className="competition-card competition-leaderboard-locked">The leaderboard will be public once the competition ends.</p>
  );

export default LeaderboardTab;
